import { render, staticRenderFns } from "./NewsMainPage.vue?vue&type=template&id=363f0380&scoped=true&"
import script from "./NewsMainPage.vue?vue&type=script&lang=js&"
export * from "./NewsMainPage.vue?vue&type=script&lang=js&"
import style0 from "./NewsMainPage.vue?vue&type=style&index=0&id=363f0380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f0380",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCol,VDivider,VIcon,VImg,VRow})
